<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
 import vHead from '@/components/common/header.vue';
export default {
  name: 'App'
}
</script>

<style lang="scss">
  @import "./style/base/_reset";
  @import "./style/style";
  .el-menu--horizontal>.el-menu-item{
    width: 160px !important;
  }
  .el-menu--collapse .el-menu .el-submenu, .el-menu--popup{
  
    min-width: 140px !important;
    height: 128px;
    border-radius: 7px !important;
    background-color: #fff !important;
    top:-1px;
    left: -10px;
    border-bottom: none !important;
    box-shadow: 0px 0px 12px 0px rgba(0,0,0,0.08) !important; 
  li{
    a{
        font-family: PingFang SC, PingFang SC-Regular !important;
        color: #333333 !important;
    }
  }
}

.el-menu-item{
  height: 50% !important;
  text-align: center;
  line-height:64px !important;
  display: block;
}
.el-menu--horizontal>.el-submenu .el-submenu__title {
 line-height:64px !important;
 font-family: PingFang SC, PingFang SC-Regular !important;
 color: #333333 !important;
}
.el-menu--horizontal>.el-menu-item.is-active{
    border-bottom-color:#fff !important;
}
.el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
  border-bottom-color:#fff !important;
}
.el-menu.el-menu--horizontal {
  border-bottom-color: #fff !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue